import moment from "moment-timezone"
import { normalizeAdminListFilters } from "helpers/adminListQueryPolicy"

export const DEFAULT_ORGANIZER_OPTIONS = { page: 1, limit: 25, sortBy: "createdAt:desc" }
export const ORGANIZER_SORT_OPTIONS = [
  { value: "createdAt:desc", label: "Newest first" },
  { value: "createdAt:asc", label: "Oldest first" },
  { value: "userId:asc", label: "Account ID ascending" },
  { value: "userId:desc", label: "Account ID descending" },
]
const FILTER_KEYS = ["search", "location", "accountType", "status", "fromDate", "toDate"]

export const readOrganizerQuery = search => {
  const params = new URLSearchParams(search)
  const filters = normalizeAdminListFilters(Object.fromEntries(
    FILTER_KEYS.map(key => [key, params.get(key)])
  ))
  const page = Number(params.get("page"))
  const limit = Number(params.get("limit"))
  const sortBy = params.get("sortBy")
  return {
    filters,
    options: {
      page: Number.isInteger(page) && page > 0 && page <= 100000 ? page : 1,
      limit: [25, 50, 100].includes(limit) ? limit : 25,
      sortBy: ORGANIZER_SORT_OPTIONS.some(option => option.value === sortBy) ? sortBy : DEFAULT_ORGANIZER_OPTIONS.sortBy,
    },
  }
}

export const writeOrganizerQuery = (filters, options) => {
  const params = new URLSearchParams(normalizeAdminListFilters(filters))
  Object.entries(options).forEach(([key, value]) => {
    if (value !== DEFAULT_ORGANIZER_OPTIONS[key]) params.set(key, value)
  })
  return params.toString() ? `?${params}` : ""
}

export const organizerDateError = ({ fromDate, toDate }) => {
  if ([fromDate, toDate].some(value => value && !moment(value, "YYYY-MM-DD", true).isValid())) {
    return "Enter valid creation dates."
  }
  return fromDate && toDate && fromDate > toDate
    ? "Created from must be on or before Created to."
    : ""
}

export const organizerListPath = search => {
  const { filters, options } = readOrganizerQuery(typeof search === "string" ? search : "")
  return `/accounts/organizers${writeOrganizerQuery(filters, options)}`
}
